import React from 'react';

import { useTranslation } from 'react-i18next';

import QuestionPrompt from './QuestionPrompt';
import NavigationButton from 'components/action/NavigationButton';

import './Decision.sass';

function Decision(props: any) {

	const { t } = useTranslation();

	return (
		<div className="Decision">
			<h2>{t('models.project.fields.name_explanation')}</h2>

			<QuestionPrompt small={props.name} answer={props.name} onClick={props.onEdit}></QuestionPrompt>

			<h2>{t('models.project.fields.context_explanation')}</h2>
			<QuestionPrompt small={props.context} answer={props.context} onClick={props.onEdit}></QuestionPrompt>

			<h2>{t('models.project.fields.description_explanation')}</h2>
			<QuestionPrompt
				small={props.description}
				answer={props.description}
				onClick={props.onEdit}
			></QuestionPrompt>

			<NavigationButton onClick={() => props.onGoNext('/projects/' + props?.id + '/' + t("models.indicator.slug"))}>
				Next step
			</NavigationButton>
		</div>
	);
}

export default Decision;
